import { render, staticRenderFns } from "./sub-text-card.vue?vue&type=template&id=42187ab7&scoped=true&"
import script from "./sub-text-card.vue?vue&type=script&lang=js&"
export * from "./sub-text-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42187ab7",
  null
  
)

export default component.exports